export async function enviarUbicacion() {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined" || !navigator.geolocation) {
      return reject(new Error("Geolocalización no está soportada o estás fuera del navegador."));
    }
 
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitud: position.coords.latitude,
          longitud: position.coords.longitude
        });
      },
      (error) => {
        reject(new Error("Error al obtener la ubicación: " + error.message));
      }
    );
  });
}
 
 